var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.332031C3.31992 0.332031 0.333252 3.3187 0.333252 6.9987C0.333252 10.6787 3.31992 13.6654 6.99992 13.6654C10.6799 13.6654 13.6666 10.6787 13.6666 6.9987C13.6666 3.3187 10.6799 0.332031 6.99992 0.332031ZM7.66659 11.6654H6.33325V10.332H7.66659V11.6654ZM9.04659 6.4987L8.44659 7.11203C7.96659 7.5987 7.66659 7.9987 7.66659 8.9987H6.33325V8.66537C6.33325 7.93203 6.63325 7.26536 7.11325 6.7787L7.93992 5.9387C8.18659 5.6987 8.33325 5.36536 8.33325 4.9987C8.33325 4.26536 7.73325 3.66536 6.99992 3.66536C6.26659 3.66536 5.66659 4.26536 5.66659 4.9987H4.33325C4.33325 3.52536 5.52659 2.33203 6.99992 2.33203C8.47325 2.33203 9.66659 3.52536 9.66659 4.9987C9.66659 5.58536 9.42659 6.1187 9.04659 6.4987Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/QuestionMarkIcon.0f7dd67c.svg";
export { ForwardRef as ReactComponent };